<template>
  <div>
    <pageTitle />
    <business-group ref="businessGroup" :tableConfig="{...tableConfig}" :formConfig="{...formConfig}">
      <template slot="formSlot" slot-scope="formSlot">
        <a-form-item>
          <a-input placeholder="搜索账号" v-decorator="['keyword']" />
        </a-form-item>
        <a-form-item>
          <a-select style="width: 150px" placeholder="账号状态" v-decorator="['enabledStatus']">
            <a-select-option v-for="el in status" :key="el.label" :value="el.value">
              {{ el.label }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </template>
      <template slot="formRight">
        <div style="text-align: right; flex: 1">
          <a-button type="primary" @click="add">新增管理员</a-button>
        </div>
      </template>
      <template slot="enabledStatus" slot-scope="record">
        <span v-text="(record.enabledStatus)? '可使用': '停用' " />
      </template>
      <template slot="action" slot-scope="record">
        <a-button type="link" @click="edit(record)">编辑</a-button>
        <a-button type="link" @click="changeUserStatus(record)">
          {{ (record.enabledStatus) ? "可使用" : "停用" }}
        </a-button>
        <a-button type="link" @click="resetpassword(record)">重置</a-button>
        <a-button type="link" style="color: red" @click="del(record)">删除</a-button>
      </template>
    </business-group>
    <a-modal
        :title="title"
        destroyOnClose
        :width="400"
        :visible="visible"
        :confirm-loading="loading"
        @ok="handleOk('ruleForm')"
        @cancel="handleCancel('ruleForm')"
        :maskClosable="false"
    >
      <a-form-model ref="ruleForm" :model="info" :label-col="labelCol" :rules="rules" :wrapper-col="wrapperCol">
        <a-form-model-item style="margin-bottom: 0" label="选择角色" prop="roleId">
          <a-select style="width: 200px" placeholder="请选择角色" v-model="info.roleId">
            <a-select-option v-for="el in admins" :key="el.id" :value="el.id">
              {{ el.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item style="margin-bottom: 0" label="账号" prop="username">
          <a-input placeholder="请输入账号" style="width: 200px" v-model="info.username" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>

</template>

<script>
import { roleSelect } from "@/api/index/system";
import { confirm, tips } from "@/utils/util";
import pageTitle from "@/components/business/pageTitle";
import businessGroup from "@/components/business/businessGroup";

const columns = [
  {
    title: "账号",
    dataIndex: "username",
    key: "username",
    align: "center"
  },
  {
    title: "角色名称",
    dataIndex: "roleName",
    key: "roleName",
    align: "center"
  },
  {
    title: "状态",
    dataIndex: "enabledStatus",
    key: "enabledStatus",
    align: "center",
    width: 200,
    scopedSlots: { customRender: "enabledStatus" }
  },
  {
    title: "操作",
    align: "center",
    width: 200,
    scopedSlots: { customRender: "action" }

  }
];


let validateValue = (rule, value, callback) => {
  if (!value || value === "") {
    callback(new Error(rule?.message || "请输入正确的信息"));
  } else {
    callback();
  }
};

export default {
  components: {
    pageTitle,
    businessGroup
  },
  data() {
    return {
      columns,
      data: [],
      accountStatus: [],

      labelCol: { span: 6 },
      wrapperCol: { span: 15 },


      tableConfig: {
        url: "/bluetoothlight/web/system/admins",
        columns,
        rowKey: "adminId",
        loading: false
      },
      formConfig: {
        formShow: true
      },
      rules: {
        roleId: [{ required: true, validator: validateValue, trigger: "change", message: "请选择角色" }],
        username: [{ required: true, validator: validateValue, trigger: "change", message: "请输入账号" }]
      },

      status: [
        { value: undefined, label: "全部" },
        { value: true, label: "可使用" },
        { value: false, label: "停用" }
      ],

      admins: [],
      roleId: undefined,


      title: undefined,
      visible: false,
      loading: false,

      record: undefined,
      info: {}

    };
  },
  created() {
    // this.getRole();

  },
  methods: {
    getRole: async function() {
      const res = await roleSelect();
      this.admins = res?.resultData;
    },
    add() {
      if (this.loading) return false;
      this.loading = true;
      this.getRole();
      this.title = "添加账号";
      this.visible = true;
      this.loading = false;
    },
    del(record) {
      if (this.loading) return false;
      const rowKey = this.tableConfig?.rowKey;
      const id = record?.[rowKey];
      const url = this.tableConfig?.url;
      if (!id || !url) return false;
      this.loading = true;
      const payload = {
        okBack: async () => {
          const res = await this.$http("DELETE", `${url}/${id}`);
          const resultStatus = res?.resultStatus;
          if (resultStatus) {
            tips(this, true);
            this.refreshData();
          }
        },
        title: `确认删除该管理员吗`
      };
      confirm(this, payload);
      setTimeout(() => {
        this.loading = false;
      }, 400);
    },

    refreshData() {
      this.$refs?.["businessGroup"]?.getData?.();
    },

    _post: async function(data = {}) {
      const rowKey = this.tableConfig?.rowKey;
      if (!rowKey) return false;

      const url = this.tableConfig?.url;
      if (this.loading || !url) return false;
      this.loading = true;
      const id = this.info?.[rowKey] || 0;
      const res = await this.$post(`${url}/${id}`, data);
      const resultStatus = res?.resultStatus;
      if (resultStatus) {
        tips(this, true);
        this.refreshData();
        this.handleCancel();
      }
      this.loading = false;
    },


    handleOk(formName) {
      if (this.loading) return false;
      if (!formName) return false;
      this.$refs[formName].validate(async valid => {
        if (!valid) return false;
        this._post(this.info);
      });
      this.loading = false;
    },
    handleCancel(formName) {
      this.$refs[formName]?.resetFields();
      this.title = undefined;
      this.record = {};
      this.info = {};
      this.visible = false;
    },
    edit(record) {
      if (this.loading) return false;
      this.loading = true;
      this.title = '编辑管理员'
      this.getRole();
      this.info = record;
      this.visible = true;
      this.loading = false;
    },
    changeUserStatus: async function(record) {
      if (this.loading) return false;
      this.loading = true;
      const url = this.tableConfig?.url;
      if (!url) return false;

      const rowKey = this.tableConfig?.rowKey;
      const id = record?.[rowKey];

      if (!id) return false;


      const payload = {
        okBack: async () => {
          const res = await this.$post(`${url}/${id}/enabledstatus`);
          const resultStatus = res?.resultStatus;
          if (resultStatus) {
            tips(this, true);
            this.refreshData();
          }
        },
        title: `是否${!(record?.enabledStatus) ? "启用" : "停用"}该管理员?`
      };
      confirm(this, payload);
      setTimeout(() => {
        this.loading = false;
      }, 400);
    },
    resetpassword: async function(record) {

      const url = this.tableConfig?.url;
      if (!url) return false;

      const rowKey = this.tableConfig?.rowKey;
      const id = record?.[rowKey];

      if (!id) return false;


      const payload = {
        okBack: async () => {
          const res = await this.$post(`${url}/${id}/resetpassword`);
          const resultStatus = res?.resultStatus;
          if (resultStatus) {
            tips(this, true);
            this.refreshData();
          }
        },
        title: `是否对该管理员重置密码`
      };
      confirm(this, payload);
      setTimeout(() => {
        this.loading = false;
      }, 400);
    }
  }
};
</script>


<style lang="less" scoped>
.header {
  display: flex;

  .admin_add {
    float: right;
    width: 100px;
    height: 30px;
    font-size: 12px;
    border: none;
    background-color: #2A82E4;
    border-radius: 5px;
    color: #fff;
  }
}
</style>
